/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AppRouteImport } from './routes/_app'
import { Route as ForgotPasswordRouteImport } from './routes/forgot-password'
import { Route as LoginRouteImport } from './routes/login'
import { Route as SetPasswordRouteImport } from './routes/set-password'
import { Route as AppDashboardRouteImport } from './routes/_app/dashboard'
import { Route as AppRelationshipManagersRouteImport } from './routes/_app/relationship-managers'
import { Route as DevComponentsRouteImport } from './routes/dev.components'
import { Route as AppProductsSettingsRouteImport } from './routes/_app/products/settings'
import { Route as AppSuppliersIndexRouteImport } from './routes/_app/suppliers.index'
import { Route as AppSuppliersSupplierIdRouteImport } from './routes/_app/suppliers.$supplierId'
import { Route as AppSuppliersNewRouteImport } from './routes/_app/suppliers.new'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const ForgotPasswordRoute = ForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const SetPasswordRoute = SetPasswordRouteImport.update({
  id: '/set-password',
  path: '/set-password',
  getParentRoute: () => rootRouteImport,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppRelationshipManagersRoute = AppRelationshipManagersRouteImport.update({
  id: '/relationship-managers',
  path: '/relationship-managers',
  getParentRoute: () => AppRoute,
} as any)
const DevComponentsRoute = DevComponentsRouteImport.update({
  id: '/dev/components',
  path: '/dev/components',
  getParentRoute: () => rootRouteImport,
} as any)
const AppProductsSettingsRoute = AppProductsSettingsRouteImport.update({
  id: '/products/settings',
  path: '/products/settings',
  getParentRoute: () => AppRoute,
} as any)
const AppSuppliersIndexRoute = AppSuppliersIndexRouteImport.update({
  id: '/suppliers/',
  path: '/suppliers/',
  getParentRoute: () => AppRoute,
} as any)
const AppSuppliersSupplierIdRoute = AppSuppliersSupplierIdRouteImport.update({
  id: '/suppliers/$supplierId',
  path: '/suppliers/$supplierId',
  getParentRoute: () => AppRoute,
} as any)
const AppSuppliersNewRoute = AppSuppliersNewRouteImport.update({
  id: '/suppliers/new',
  path: '/suppliers/new',
  getParentRoute: () => AppRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/set-password': typeof SetPasswordRoute
  '/dashboard': typeof AppDashboardRoute
  '/relationship-managers': typeof AppRelationshipManagersRoute
  '/dev/components': typeof DevComponentsRoute
  '/products/settings': typeof AppProductsSettingsRoute
  '/suppliers/$supplierId': typeof AppSuppliersSupplierIdRoute
  '/suppliers/new': typeof AppSuppliersNewRoute
  '/suppliers/': typeof AppSuppliersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/set-password': typeof SetPasswordRoute
  '/dashboard': typeof AppDashboardRoute
  '/relationship-managers': typeof AppRelationshipManagersRoute
  '/dev/components': typeof DevComponentsRoute
  '/products/settings': typeof AppProductsSettingsRoute
  '/suppliers/$supplierId': typeof AppSuppliersSupplierIdRoute
  '/suppliers/new': typeof AppSuppliersNewRoute
  '/suppliers': typeof AppSuppliersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/forgot-password': typeof ForgotPasswordRoute
  '/login': typeof LoginRoute
  '/set-password': typeof SetPasswordRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/relationship-managers': typeof AppRelationshipManagersRoute
  '/dev/components': typeof DevComponentsRoute
  '/_app/products/settings': typeof AppProductsSettingsRoute
  '/_app/suppliers/$supplierId': typeof AppSuppliersSupplierIdRoute
  '/_app/suppliers/new': typeof AppSuppliersNewRoute
  '/_app/suppliers/': typeof AppSuppliersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/set-password'
    | '/dashboard'
    | '/relationship-managers'
    | '/dev/components'
    | '/products/settings'
    | '/suppliers/$supplierId'
    | '/suppliers/new'
    | '/suppliers/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/forgot-password'
    | '/login'
    | '/set-password'
    | '/dashboard'
    | '/relationship-managers'
    | '/dev/components'
    | '/products/settings'
    | '/suppliers/$supplierId'
    | '/suppliers/new'
    | '/suppliers'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/forgot-password'
    | '/login'
    | '/set-password'
    | '/_app/dashboard'
    | '/_app/relationship-managers'
    | '/dev/components'
    | '/_app/products/settings'
    | '/_app/suppliers/$supplierId'
    | '/_app/suppliers/new'
    | '/_app/suppliers/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  ForgotPasswordRoute: typeof ForgotPasswordRoute
  LoginRoute: typeof LoginRoute
  SetPasswordRoute: typeof SetPasswordRoute
  DevComponentsRoute: typeof DevComponentsRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/forgot-password': {
      id: '/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof ForgotPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/set-password': {
      id: '/set-password'
      path: '/set-password'
      fullPath: '/set-password'
      preLoaderRoute: typeof SetPasswordRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/relationship-managers': {
      id: '/_app/relationship-managers'
      path: '/relationship-managers'
      fullPath: '/relationship-managers'
      preLoaderRoute: typeof AppRelationshipManagersRouteImport
      parentRoute: typeof AppRoute
    }
    '/dev/components': {
      id: '/dev/components'
      path: '/dev/components'
      fullPath: '/dev/components'
      preLoaderRoute: typeof DevComponentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/products/settings': {
      id: '/_app/products/settings'
      path: '/products/settings'
      fullPath: '/products/settings'
      preLoaderRoute: typeof AppProductsSettingsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/suppliers/': {
      id: '/_app/suppliers/'
      path: '/suppliers'
      fullPath: '/suppliers/'
      preLoaderRoute: typeof AppSuppliersIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/suppliers/$supplierId': {
      id: '/_app/suppliers/$supplierId'
      path: '/suppliers/$supplierId'
      fullPath: '/suppliers/$supplierId'
      preLoaderRoute: typeof AppSuppliersSupplierIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/suppliers/new': {
      id: '/_app/suppliers/new'
      path: '/suppliers/new'
      fullPath: '/suppliers/new'
      preLoaderRoute: typeof AppSuppliersNewRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppDashboardRoute: typeof AppDashboardRoute
  AppRelationshipManagersRoute: typeof AppRelationshipManagersRoute
  AppProductsSettingsRoute: typeof AppProductsSettingsRoute
  AppSuppliersSupplierIdRoute: typeof AppSuppliersSupplierIdRoute
  AppSuppliersNewRoute: typeof AppSuppliersNewRoute
  AppSuppliersIndexRoute: typeof AppSuppliersIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppDashboardRoute: AppDashboardRoute,
  AppRelationshipManagersRoute: AppRelationshipManagersRoute,
  AppProductsSettingsRoute: AppProductsSettingsRoute,
  AppSuppliersSupplierIdRoute: AppSuppliersSupplierIdRoute,
  AppSuppliersNewRoute: AppSuppliersNewRoute,
  AppSuppliersIndexRoute: AppSuppliersIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  ForgotPasswordRoute: ForgotPasswordRoute,
  LoginRoute: LoginRoute,
  SetPasswordRoute: SetPasswordRoute,
  DevComponentsRoute: DevComponentsRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
